import React, { useEffect, useState } from 'react';

const MobileStickyBar = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-4 left-4 right-4 z-40 transition-all duration-500 ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6 pointer-events-none'
      }`}
    >
      <a
        href="/activate"
        className="block w-full text-center bg-navy text-warm border border-gold py-4 shadow-[0_10px_30px_-8px_rgba(15,35,64,0.35)] chapter-badge uppercase"
      >
        Activate Your Voucher
      </a>
    </div>
  );
};

export default MobileStickyBar;
